export default {
    methods: {
        checkHelp() {
            if (this.$refs.main_section === undefined) return false;
            let helpExists = this.$refs.main_section.getHelp();
            if ((helpExists === undefined) || !helpExists) return false;
            return true;
          }
    }
}